import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Award, Heart, PartyPopper, Sparkles } from 'lucide-react';
import styles from './BottomTabBar.module.css';

const tabs = [
  { path: '/dashboard', icon: Home, label: 'Home' },
  { path: '/feed', icon: Award, label: 'Spotlight' },
  { path: '/appreciate', icon: Heart, label: 'Send', isCenter: true },
  { path: '/celebrations', icon: PartyPopper, label: 'Celebrations' },
  { path: '/my-space', icon: Sparkles, label: 'You' },
];

const BottomTabBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className={styles.tabBar}>
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path || location.pathname.startsWith(tab.path + '/');

        if (tab.isCenter) {
          return (
            <button
              key={tab.path}
              className={styles.centerTab}
              onClick={() => navigate(tab.path)}
            >
              <div className={styles.centerIcon}>
                <tab.icon size={18} fill="#fff" strokeWidth={0} />
              </div>
              <span className={`${styles.tabLabel} ${styles.centerLabel}`}>{tab.label}</span>
            </button>
          );
        }

        return (
          <button
            key={tab.path}
            className={`${styles.tab} ${isActive ? styles.active : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <tab.icon size={20} />
            <span className={styles.tabLabel}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomTabBar;
